import { Formik } from "formik";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, getGradeOptions, GradeLevelOptions } from "../../../../../../_helpers/Helpers";

export function GradeCourseEditForm({
  gradeOptions,
  gradeCourse,    
  btnRef,
  setGradeOptions,
  saveCourse
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={gradeCourse}
      onSubmit={(values) => {
        if (values.credit === "") values.credit = null;
        saveCourse(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="course">
            <Form.Label column sm={2}>
              Ders<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={gradeCourse.courses}
                value={values.courseId}
                onChange={option => handleChange("courseId")(option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="gradeLevel">
            <Form.Label column sm={2}>
              Sınıf Düzeyi<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={GradeLevelOptions}
                value={values.gradeLevel}
                onChange={option => {
                  const options = getGradeOptions(option.value);
                  setGradeOptions(options);
                  setFieldValue("gradeLevel", option.value);
                  if (options.length === 1) setFieldValue("grade", options[0].value);
                  else if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", null);
                }}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="grade">
            <Form.Label column sm={2}>
              Sınıf<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={gradeOptions}
                value={values.grade}
                onChange={option => handleChange("grade")(option.value)}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="credit">
            <Form.Label column sm={2}>
              Kredisi<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="number" min="1" value={values.credit} placeholder="Kredisi" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="displayOnTheSchoolReport">
            <Form.Label column sm={2}>
              Karnede Görünsün mü?
            </Form.Label>
            <Col sm={10}>
              <Switch checked={values.displayOnTheSchoolReport} onChange={handleChange("displayOnTheSchoolReport")} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}
    </Formik>
  );
}